module.exports = __webpack_public_path__ + "static/media/intro-photowall-30.fa26f741.jpg";